const allowedLocales = ["en-au", "en-ca"];
const chatbotEnabledPages = [""];

export { allowedLocales, chatbotEnabledPages };
//# sourceMappingURL=src-config-ubik-config.js.map
